import { useMemo, useState } from "react";
import PropTypes from "prop-types";
import toast from "react-hot-toast";
import ServiceBox from "./ServiceBox";
import "./ServicesGrid.scss";
import { useServices } from "@/hooks/useServices";

const ServicesGrid = ({ onServiceClick }) => {
  const [selectedServiceId, setSelectedServiceId] = useState(null);
  const { services, isLoading, error } = useServices();

  const orderedServices = useMemo(
    () =>
      [...services]
        .filter(service => Boolean(service.serStatus))
        .sort(
          (a, b) => (a.position ?? Number.MAX_SAFE_INTEGER) - (b.position ?? Number.MAX_SAFE_INTEGER)
        ),
    [services]
  );

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    toast.error(error.message);
    return <div>Error loading services</div>;
  }

  const handleServiceClick = (service) => {
    setSelectedServiceId(service.id);
    onServiceClick(service);
  };

  return (
    <div className="services-grid">
      {orderedServices.map((service) => (
        <ServiceBox
          key={service.id}
          avatar={service.serAvatar}
          title={service.serTitle}
          description={service.serDescription}
          disableTooltip
          className={selectedServiceId === service.id ? "serviceClick" : ""}
          onClick={() => handleServiceClick(service)}
        />
      ))}
    </div>
  );
};

ServicesGrid.propTypes = {
  onServiceClick: PropTypes.func.isRequired,
};

export default ServicesGrid;
